import { JDSBadgeV2StatusProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<JDSBadgeV2StatusProps>
  ): React.FC<JDSBadgeV2StatusProps> =>
  (props: JDSBadgeV2StatusProps) => {
    return <Component {...props} />;
  };
